import { render } from "./qa-standard.vue?vue&type=template&id=1bf2254c&scoped=true"
import script from "./qa-standard.vue?vue&type=script&lang=js"
export * from "./qa-standard.vue?vue&type=script&lang=js"

import "./qa-standard.vue?vue&type=style&index=0&id=1bf2254c&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf2254c"]])

export default __exports__